export const SPOUSE_CHANGE_REASON_CODES = [
  'divorce',
  'death',
  'dependent_end',
  'moved_overseas',
  'other',
] as const;

export type SpouseChangeReasonCode = (typeof SPOUSE_CHANGE_REASON_CODES)[number];

export function isSpouseChangeReasonCode(value: string): value is SpouseChangeReasonCode {
  return (SPOUSE_CHANGE_REASON_CODES as readonly string[]).includes(value);
}

export function changeReasonLabelKey(code: SpouseChangeReasonCode): string {
  return `submitDocuments.dependentDeduction.spouse.changeReason.option.${code}`;
}

